import React from 'react'
import { MenuItem, TextField } from '@mui/material'
import { ComponentProps } from '../../../types/filters'
import { eLpnState } from '../../../enums/eLpnState'

export const LpnStateFilter: React.FC<ComponentProps> = ({
  value,
  onChange,
  fullWidth = true,
  variant = 'outlined'
}) => {
  const lpnStateOptions = [
    { value: eLpnState.Created, label: 'Creado' },
    { value: eLpnState.Pending, label: 'Pendiente' },
    { value: eLpnState.Finished, label: 'Finalizado' },
    { value: eLpnState.Manage, label: 'Gestionar' }
  ]

  return (
    <TextField
      variant={variant}
      id="lpnStateId"
      name="lpnStateId"
      select
      value={value || '-1'}
      onChange={onChange}
      fullWidth={fullWidth}
    >
      <MenuItem key={-1} value={-1}>
        Seleccionar Estado LPN...
      </MenuItem>
      {lpnStateOptions.map((state) => (
        <MenuItem key={state.value} value={state.value}>
          {state.label}
        </MenuItem>
      ))}
    </TextField>
  )
}
